import { Chip } from '@atlas/components';
import classNames from 'classnames';
import useCasinoCategories from 'pages/CasinoPage/useCasinoCategories';
import { type FC, useCallback } from 'react';
import { useLocation } from 'wouter';

import { type Item, ItemType } from './types';

import styles from './CasinoCategories.module.scss';

const CategoriesListChip: FC<Item> = ({ active, icon, id, name, type }) => {
  const [pathname, navigate] = useLocation();
  const { onChange } = useCasinoCategories();

  const onClickHandler = useCallback(() => {
    if (active) return;

    if (type === ItemType.favorites) {
      navigate(`${pathname}/favorites`);
      return;
    }

    if (type === ItemType.category) {
      onChange({ type: ItemType.category, id });
    } else {
      onChange({ type });
    }
  }, [active, id, onChange, navigate, pathname, type]);

  return (
    <Chip
      label={name}
      onClick={onClickHandler}
      active={active}
      icon={icon}
      className={classNames({
        [styles.active]: active,
      })}
    />
  );
};

export default CategoriesListChip;
